import { useState } from 'react';
import styled from 'styled-components';

import { colors } from 'styles/theme/colors';
import EyeOutlineIcon from 'svg/EyeOutlineIcon';

import { maskSsn } from './ssn';

// The SSN as shown on read-only surfaces: masked, with an eye to reveal it (UX, 2026-08-04).
// Both the header chips and the extraction card render it through here so the two can't drift —
// a masking rule that lives in two places eventually only holds in one.
//
// Revealing is deliberately one-way and deliberately NOT persisted. The icon disappears once
// clicked (there's no re-hide), and the state lives in this component, so leaving the referral
// unmounts it and the next visit is masked again. That's the whole security story: the default is
// masked on every arrival, and revealing is an explicit act each time rather than a preference
// that quietly sticks.
export default function RevealableSsn({ ssn }: { ssn: string }) {
  const [revealed, setRevealed] = useState(false);

  if (revealed) return <>{ssn}</>;

  return (
    <>
      {maskSsn(ssn)}
      <Reveal
        type='button'
        onClick={() => setRevealed(true)}
        aria-label='Reveal Social Security Number'
        data-testid='reveal-ssn'>
        <EyeOutlineIcon width={14} height={14} />
      </Reveal>
    </>
  );
}

const Reveal = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-left: 6px;
  cursor: pointer;
  vertical-align: middle;
  color: ${colors.black50};
  line-height: 0;

  &:hover {
    color: ${colors.black100};
  }
`;
